import { useEffect, useRef } from "react";
import type { MoveDto, PlayerDto } from "@chess/shared";

/** Pairs half-moves into the numbered rows a chess player expects. */
function toRows(moves: readonly MoveDto[]) {
  const rows: { number: number; white?: MoveDto; black?: MoveDto }[] = [];
  for (const move of moves) {
    const number = Math.ceil(move.ply / 2);
    const isWhite = move.ply % 2 === 1;
    const row = rows[number - 1] ?? { number };
    if (isWhite) row.white = move;
    else row.black = move;
    rows[number - 1] = row;
  }
  return rows;
}

export function MoveList({
  moves,
  players = [],
  selectedPly,
}: {
  moves: readonly MoveDto[];
  players?: readonly PlayerDto[];
  selectedPly?: number;
}) {
  const scroller = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = scroller.current;
    if (element) element.scrollTop = element.scrollHeight;
  }, [moves.length]);

  if (moves.length === 0) {
    return (
      <div className="card">
        <p className="muted">No moves yet.</p>
      </div>
    );
  }

  return (
    <div className="card movelist" ref={scroller}>
      <table>
        <tbody>
          {toRows(moves).map((row) => (
            <tr key={row.number}>
              <td className="movelist__num">{row.number}.</td>
              <td className={row.white?.ply === selectedPly ? "movelist__selected" : undefined}>{row.white ? <Move move={row.white} players={players} /> : ""}</td>
              <td className={row.black?.ply === selectedPly ? "movelist__selected" : undefined}>{row.black ? <Move move={row.black} players={players} /> : ""}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function Move({ move, players }: { move: MoveDto; players: readonly PlayerDto[] }) {
  const player = players.find((entry) => entry.userId === move.userId);
  return <span title={player ? `Selected from ${player.username}'s ballot` : undefined}>{move.san}{player ? <small className="movelist__player">{player.username}</small> : null}</span>;
}
